import React, { useEffect, useRef, useState } from 'react';
import type { ColumnsType } from 'antd/es/table';
import { Form, Table, useBreadcrumbRoutes, Wrapper, Button, FormTitle, EllipsisSpan } from '@maxtropy/components';
import styles from './index.module.scss';
import {
  apiV2PowerRoomConfigPowerSystemConfigurationListPost,
  V2PowerRoomConfigPowerSystemConfigurationListPostResponse,
} from '@maxtropy/device-customer-apis-v2';
import AssociateModal from './AssociateModal';
import dayjs from 'dayjs';

const routes = [{ name: `电力系统组态状态配置列表` }];

interface Props {
  isEdit?: boolean;
}
export type DataType = Exclude<V2PowerRoomConfigPowerSystemConfigurationListPostResponse['list'], undefined>[number];
type GroupsStatusProps = V2PowerRoomConfigPowerSystemConfigurationListPostResponse['list'];
const GroupsStatusConfiglist: React.FC<Props> = ({ isEdit }) => {
  const [form] = Form.useForm();
  const breadcrumbRoutes = useBreadcrumbRoutes();
  const [associateVisable, setAssociateVisable] = useState<boolean>(false);
  const [datasList, setdatasList] = useState<GroupsStatusProps>();
  const [currentLabelId, setCurrentLabelId] = useState<number>();
  const [currentLinkIds, setCurrentLinkIds] = useState<number[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const modalRef = useRef(null);
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    setLoading(true);
    apiV2PowerRoomConfigPowerSystemConfigurationListPost({})
      .then(res => {
        setdatasList(res.list ?? []);
      })
      .finally(() => setLoading(false));
  };
  const columns: ColumnsType<DataType> = [
    {
      title: '母排',
      dataIndex: 'name',
    },
    {
      title: '对应回路名称',
      dataIndex: 'circuitList',
      render: circuitList => {
        if (!circuitList || circuitList.length === 0) {
          return '-';
        }
        return circuitList.map((item: any) => item.name || '未命名').join('，');
      },
    },
    {
      title: '最后操作人',
      dataIndex: 'operator',
      render: (v: string) => <EllipsisSpan value={v} />,
    },
    {
      title: '最后操作时间',
      dataIndex: 'updateTime',
      render: (v: string) => {
        return !v ? '-' : dayjs(v).format('YYYY-MM-DD HH:mm:ss');
      },
    },
    {
      title: '操作',
      dataIndex: 'option',
      width: 120,
      render: (_, record: DataType) => {
        return (
          <Button
            type="link"
            onClick={() => {
              const circuiRes =
                record.circuitList?.map(i => i.id).filter((id): id is number => typeof id === 'number') ?? [];
              setCurrentLinkIds(circuiRes);
              setCurrentLabelId(record.id);
              setAssociateVisable(true);
            }}
          >
            关联回路
          </Button>
        );
      },
    },
  ];
  return (
    <Wrapper routes={[...(breadcrumbRoutes?.routes ?? []), ...routes]} className={styles.wrapper}>
      <FormTitle title="组态状态配置列表"></FormTitle>
      <Table columns={columns} dataSource={datasList} loading={loading}></Table>
      {associateVisable && (
        <AssociateModal
          linkIds={currentLinkIds}
          busPaiId={currentLabelId}
          onCancel={() => setAssociateVisable(false)}
          onConfirm={() => {
            setAssociateVisable(false);
            fetchData();
          }}
        />
      )}
    </Wrapper>
  );
};

export default GroupsStatusConfiglist;
